import { useCurrentLocale } from '@/locales/client'
import { PropsWithChildren } from 'react'

type Props = {
  className?: string
  onLoad?(): void
}

function LoginIframe({ className, onLoad }: PropsWithChildren<Props>) {
  const locale = useCurrentLocale()
  return (
    <iframe
      title='Sign in'
      onLoad={onLoad}
      src={`/${locale}/login`}
      className={className}
    />
  )
}

export default LoginIframe
